import { Box, CssBaseline } from '@ds/coolshop';
import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { CartProvider } from './_new/modules/cpq/components/Cart/CartContext';
import { CartDrawer } from './_new/modules/cpq/components/Cart/CartDrawer';
import { usePageBgColor } from './_new/modules/settings/hooks/usePageBgColor';
import DirtyNavigationBlocker from './components/hierarchies/shared/DirtyNavigationBlocker';
import { DelayedFallback } from './components/layout/DelayedFallback';
import { PimAppBar } from './components/layout/PimAppBar';

const Layout = () => {
    const { pathname } = useLocation();
    const pageBgColor = usePageBgColor();
    const isCGTPrototypesPage = pathname.split('/')[1] === 'prototypes';

    return (
        <CartProvider>
            <Box>
                <CssBaseline />
                <DirtyNavigationBlocker />
                {!isCGTPrototypesPage && <PimAppBar />}
                <Box
                    bgcolor={pageBgColor}
                    flexGrow={!isCGTPrototypesPage ? 1 : undefined}
                    height={!isCGTPrototypesPage ? 'calc(100vh - 64px)' : undefined}
                    overflow={!isCGTPrototypesPage ? 'auto' : undefined}
                    marginTop={!isCGTPrototypesPage ? '64px' : undefined} // TODO this is the height of the appBar
                >
                    {/* The pages are lazy(). Without a boundary here their suspension reaches
                        the one above the router, and React hides everything under it, this bar
                        included, with `display: none` while the chunk loads. An AppBar menu
                        closing at that moment never gets the transitionend its exit animation
                        waits for, so MUI leaves the portal mounted and its backdrop keeps
                        swallowing every click on the page. */}
                    <CartDrawer>
                        <Suspense fallback={<DelayedFallback />}>
                            <Outlet />
                        </Suspense>
                    </CartDrawer>
                </Box>
            </Box>
        </CartProvider>
    );
};

export default Layout;
